module.exports = __webpack_public_path__ + "img/jodit-image.f21d1139.svg";